import { axios } from '@/services/axios';

const deleteAddress = async (addressID) => {
    const res = await axios.delete(`/address/${addressID}`);
    return res.data;
};

export default deleteAddress;
